import Vue from "vue";
import Vuex from "vuex";
import customer from './modules/customer'
import authentication from './modules/authentication'
import storeManager from './modules/storeManager'
import tracking from './modules/tracking'
import bigPackage from './modules/bigPackage'
import bigPackageVN from './modules/bigPackageVN'
import storage from './modules/storage'
import productType from './modules/productType'
import feeWeight from './modules/feeWeight'
import feeVolume from './modules/feeVolume'
import configuration from './modules/configuration'
import product from './modules/product'
import staff from './modules/staff'
import payOrder from './modules/payOrder'
import paymentHistory from './modules/paymentHistory'
import rechargeHistory from './modules/rechargeHistory'
import exportReceipt from './modules/exportReceipt'
import report from './modules/report'
import commons from './modules/commons'
import createPersistedState from 'vuex-persistedstate';
import order from './modules/order'
import orderProduct from './modules/orderProduct'
import bill from './modules/bill'
import wuliu from './modules/wuliu'
import payment from "./modules/payment";
import permission from './modules/permission'
import systemLog from './modules/systemLog'
import cnService from './modules/cnService'
import cnOrder from './modules/cnOrder'
import cnDelivery from './modules/cnDelivery'
import cnPayment from './modules/cnPayment'
import cnTruck from './modules/cnTruck'
import cnOrderProduct from './modules/cnOrderProduct'
import cnWaybill from './modules/cnWaybill'
import notification from './modules/notification'
import auditLog from './modules/auditLog'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    customer,
    authentication,
    tracking,
    storeManager,
    bigPackage,
    bigPackageVN,
    feeWeight,
    feeVolume,
    configuration,
    staff,
    payOrder,
    paymentHistory,
    report,
    rechargeHistory,
    exportReceipt,
    storage,
    productType,
    product,
    commons,
    order,
    orderProduct,
    bill,
    wuliu,
    payment,
    permission,
    systemLog,
    cnService,
    cnOrder,
    cnDelivery,
    cnPayment,
    cnTruck,
    cnOrderProduct,
    cnWaybill,
    notification,
    auditLog
  },
  state: {},
  mutations: {},
  actions: {},
  strict: false,
  plugins: [createPersistedState({
    paths: [
      'authentication',
      'commons',
      'roles',
      'permission.matrix'
    ],
    storage: window.localStorage,
    rehydrated(store) {
      store.commit('permission/rehydrate');
    }
  })]
});
